import { useLang } from '@/i18n';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionG');
    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfSection
                hasAnimation={false}
                pc="https://websiteoss.ecoflow.com/upload/image/1723021933313/A%20single%20source%20to%20power%20almost%20all%20of%20your%20essential%20home%20appliances.jpg"
                title={t('title')}
                desc={t('desc')}
            />
            <EfSpec className="SectionG-spec2" />
        </div>
    );
}
